import { render, staticRenderFns } from "./ShipmentBarcodeModal.vue?vue&type=template&id=673ea361"
import script from "./ShipmentBarcodeModal.vue?vue&type=script&lang=js"
export * from "./ShipmentBarcodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports